
import { Directive, HostBinding, HostListener, Optional, Self } from '@angular/core';
import { MatDatepickerInput } from '@angular/material/datepicker';

@Directive({
  selector: 'input[matDatepicker]',
})
export class AutoOpenDatepickerDirective {
  @HostBinding('style.cursor') get cursor() {
    return this.datepickerInput?.disabled ? 'default' : 'pointer';
  }

  constructor(
    @Optional() @Self() private datepickerInput: MatDatepickerInput<unknown>
  ) { }

  @HostListener('click')
  onClick(): void {
    if (!this.datepickerInput || this.datepickerInput.disabled) {
      return;
    }

    const datepicker = (this.datepickerInput as unknown as {
      _datepicker?: { opened: boolean; open(): void };
    })._datepicker;

    if (datepicker && !datepicker.opened) {
      datepicker.open();
    }
  }
}
